import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query";
import { baseUrl } from "../../utils/api";

// Define the base query function with the base URL
const baseQuery = fetchBaseQuery({ baseUrl: baseUrl });

// Create the API slice
export const api = createApi({
  reducerPath: "api",
  baseQuery,
  endpoints: (builder) => ({
    searchPlates: builder.query({
      query: (searchTerm) => `/plate/search/new-style/${searchTerm}`,
    }),
  }),
});

// Export the auto-generated hooks for easy usage
export const { useSearchPlatesQuery } = api;
